import React from 'react';
import { ACHIEVEMENT_TYPE, KEYS, SECONDARY_COLOR } from '../constants';
import { KVC2026_STATE_REWARD_OPTIONS } from '../constants/kvc2026.config';

// Lưu ý dưới mỗi mục: chữ nhỏ, in nghiêng, màu đỏ (giống QCV).
const redNote = (children) => (
  <span
    style={{
      display: 'block',
      marginTop: 4,
      fontSize: 12,
      fontStyle: 'italic',
      fontWeight: 400,
      color: SECONDARY_COLOR,
    }}
  >
    {children}
  </span>
);

// B. THÀNH TÍCH KHOA HỌC — 02 nhóm: công bố quốc tế (1.x) & trong nước (2.x).
export const kvcAchievementFields = ({ achievementData, actions }) => [
  {
    index: '1',
    title: 'Công trình công bố quốc tế',
    children: [
      {
        index: '1.1',
        actions,
        type: ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL,
        title: (
          <>
            Bài báo Khoa học (thuộc ngành/liên ngành xét trao Giải thưởng) được
            đăng trên tạp chí quốc tế
            {redNote(
              '(Ứng viên chỉ khai báo tạp chí trong CSDL Scopus, Web of Science hoặc được xuất bản bởi NXB của 500 trường đại học hàng đầu thế giới theo xếp hạng THE.)'
            )}
            {redNote(
              'Lưu ý: Danh sách các hội thảo/hội nghị khoa học uy tín trong và ngoài nước áp dụng theo quy định hiện hành của Hội đồng Giáo sư Nhà nước và Quỹ Nafosted.'
            )}
          </>
        ),
        data: achievementData?.[ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL],
      },
      {
        index: '1.2',
        actions,
        type: ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT + KEYS.INTERNATIONAL,
        title: (
          <>
            Bài báo khoa học (thuộc ngành/liên ngành xét trao Giải thưởng) được
            in trong kỷ yếu hội thảo quốc tế đã xuất bản có ISBN được tính trong
            CSDL Scopus, web of science hay được xuất bản ở nước ngoài.
            {redNote(
              'Lưu ý: Các bài báo khoa học in trong kỷ yếu hội thảo được xuất bản ở trong nước thì sẽ tính điểm như bài báo trong nước.'
            )}
          </>
        ),
        data: achievementData?.[ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT + KEYS.INTERNATIONAL],
      },
      {
        index: '1.3',
        actions,
        type: ACHIEVEMENT_TYPE.MONOGRAPH + KEYS.INTERNATIONAL,
        title: (
          <>
            Sách chuyên khảo, giáo trình, sách tham khảo, chương sách (thuộc
            ngành/liên ngành xét trao Giải thưởng) được NXB uy tín trên thế giới
            xuất bản
            {redNote(
              'Lưu ý: Nhà xuất bản có trong dữ liệu của Web of Sciences. Danh sách các nhà xuất bản uy tín trong và ngoài nước áp dụng theo quy định hiện hành của Hội đồng Giáo sư Nhà nước và Quỹ Nafosted.'
            )}
          </>
        ),
        data: achievementData?.[ACHIEVEMENT_TYPE.MONOGRAPH + KEYS.INTERNATIONAL],
      },
    ],
  },
  {
    index: '2',
    title: 'Công trình công bố trong nước',
    children: [
      {
        index: '2.1',
        actions,
        type: ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.DOMESTIC,
        title: (
          <>
            Bài báo khoa học (thuộc ngành/liên ngành xét trao Giải thưởng) được
            đăng trên tạp chí khoa học trong nước
            {redNote(
              'Lưu ý: chỉ đánh giá các bài báo thuộc danh mục tạp chí được tính 0,75 đến 1 điểm cho ngành mà ứng viên đăng ký theo Hội đồng Giáo sư Nhà nước.'
            )}
          </>
        ),
        data: achievementData?.[ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.DOMESTIC],
      },
      {
        index: '2.2',
        actions,
        type: ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT + KEYS.DOMESTIC,
        title: (
          <>
            Báo cáo khoa học (thuộc ngành/liên ngành xét trao Giải thưởng) được
            đăng trên hội thảo/hội nghị cấp ngành hoặc cấp toàn quốc.
          </>
        ),
        data: achievementData?.[ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT + KEYS.DOMESTIC],
      },
      {
        index: '2.3',
        actions,
        type: ACHIEVEMENT_TYPE.MONOGRAPH + KEYS.DOMESTIC,
        title: (
          <>
            Sách chuyên khảo, chương sách, giáo trình (thuộc ngành/liên ngành xét
            trao Giải thưởng) được NXB uy tín trong nước xuất bản.
          </>
        ),
        data: achievementData?.[ACHIEVEMENT_TYPE.MONOGRAPH + KEYS.DOMESTIC],
      },
      {
        index: '2.4',
        actions,
        type: ACHIEVEMENT_TYPE.RESEARCH_PROJECT,
        title: 'Chương trình, dự án, đề tài nghiên cứu khoa học đã nghiệm thu.',
        data: achievementData?.[ACHIEVEMENT_TYPE.RESEARCH_PROJECT],
      },
    ],
  },
];

// C. THÀNH TÍCH KHEN THƯỞNG VÀ HOẠT ĐỘNG CỘNG ĐỒNG
//   Nhóm 1: Thành tích khen thưởng (1.1 cấp Nhà nước, 1.2 Bộ/ban/ngành/tỉnh)
//   Nhóm 2: Hoạt động cộng đồng (2.1 chia sẻ tri thức, 2.2 tình nguyện)
export const kvcActivityFields = ({
  isMobileMode,
  stateReward,
  setStateReward,
  ministryReward,
  setMinistryReward,
  personalAchievement,
  setPersonalAchievement,
  socialActivity,
  setSocialActivity,
}) => [
  {
    key: 'khen_thuong',
    title: '1. Thành tích khen thưởng',
    children: [
      {
        key: KEYS.OTHER_ACHIEVEMENT,
        values: stateReward,
        setValues: setStateReward,
        label: '1.1. Được nhận hình thức khen thưởng cấp Nhà nước',
        fields: [
          { key: `${KEYS.OTHER_ACHIEVEMENT}Content`, width: isMobileMode ? 12 : 4, label: 'Nội dung khen thưởng', required: true },
          { key: `${KEYS.OTHER_ACHIEVEMENT}Type`, width: isMobileMode ? 12 : 3, label: 'Hình thức', options: KVC2026_STATE_REWARD_OPTIONS, required: true },
          { key: `${KEYS.OTHER_ACHIEVEMENT}PreviewFile`, label: 'Minh chứng:', width: isMobileMode ? 12 : 4, type: 'file', required: true },
        ],
      },
      {
        key: 'ministryReward',
        values: ministryReward,
        setValues: setMinistryReward,
        label: '1.2. Được nhận Bằng khen Bộ, ban, ngành, tỉnh',
        fields: [
          { key: 'ministryRewardContent', width: isMobileMode ? 12 : 7, label: 'Nội dung khen thưởng', required: true },
          { key: 'ministryRewardPreviewFile', label: 'Minh chứng:', width: isMobileMode ? 12 : 4, type: 'file', required: true },
        ],
      },
    ],
  },
  {
    key: 'cong_dong',
    title: '2. Hoạt động cộng đồng',
    children: [
      {
        key: KEYS.PERSONAL_ACHIEVEMENT,
        values: personalAchievement,
        setValues: setPersonalAchievement,
        label: '2.1. Tham gia các hoạt động chia sẻ tri thức, tập huấn, đào tạo... trong ngành/liên ngành xét trao Giải thưởng',
        fields: [
          { key: `${KEYS.PERSONAL_ACHIEVEMENT}Content`, width: isMobileMode ? 12 : 7, label: 'Hình thức và nội dung thành tích', required: true },
          { key: `${KEYS.PERSONAL_ACHIEVEMENT}PreviewFile`, width: isMobileMode ? 12 : 4, label: 'Minh chứng', type: 'file', required: true },
        ],
      },
      {
        key: KEYS.SOCIAL_ACTIVITY,
        values: socialActivity,
        setValues: setSocialActivity,
        label: '2.2. Tham gia các hoạt động tình nguyện vì cộng đồng nói chung',
        fields: [
          { key: `${KEYS.SOCIAL_ACTIVITY}Content`, width: isMobileMode ? 12 : 7, label: 'Hình thức và nội dung thành tích', required: true },
          { key: `${KEYS.SOCIAL_ACTIVITY}PreviewFile`, width: isMobileMode ? 12 : 4, label: 'Minh chứng', type: 'file', required: true },
        ],
      },
    ],
  },
];

// Quá trình học tập, công tác — render trong phần THÔNG TIN CÁ NHÂN.
export const kvcPersonalProcessField = ({ isMobileMode, personalProcess, setPersonalProcess }) => ({
  key: KEYS.PERSONAL_PROCESS,
  values: personalProcess,
  setValues: setPersonalProcess,
  label: 'Quá trình học tập, công tác',
  fields: [
    { key: 'startAt', width: isMobileMode ? 12 : 2, label: 'Thời gian bắt đầu', type: 'date', required: true },
    { key: 'finishAt', width: isMobileMode ? 12 : 2, label: 'Thời gian kết thúc', type: 'date', required: true },
    { key: 'department', width: isMobileMode ? 12 : 3, label: 'Đơn vị công tác', required: true },
    { key: 'works', width: isMobileMode ? 12 : 4, label: 'Công việc đảm nhiệm', required: true },
  ],
});
